<template>
  <div class="boards-navigator">
    <v-container grid-list-lg text-xs-center class="pa-4">
      <v-layout row wrap>
        <v-flex xs12 class="group-name">{{ name }}</v-flex>
        <v-flex v-if="!filterBoards.length" xs12 class="group-empty-message">{{ empty }}</v-flex>
        <v-flex v-for="( board, index ) in filterBoards"
          :key="index"
          xs3
        >
          <board-mini
            :board="board"
            :toolbar="addBoardEnabled"
            :favorite="false"
            @click="selectBoard( board )"
            @share="shareBoard( board )"
            @favorite="favoriteBoard"
            @edit="editBoard( board )"
            @delete="deleteBoard( board )"
          ></board-mini>
        </v-flex>
        <v-flex v-if="addBoardEnabled" xs3 class="pa-2">
          <div class="add-board" @click="addBoard">+ Добавить доску</div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<style>

  .boards-navigator {
    width: 800px;
  }

  .boards-navigator .group-name {
    color: #333;
    font-size: 20px;
    text-align: left;
  }

  .boards-navigator .group-empty-message {
    color: #777787;
    font-size: 16px;
    text-align: left;
  }

  .boards-navigator .add-board {
    background-color: #ccccd7;
    border-radius: 4px;
    color: #777787;
    cursor: pointer;
    font-size: 15px;
    min-height: 100px;
    padding: 10px;
    padding-top: 38px;
    text-transform: none;
    width: 100%;
  }

  .boards-navigator .add-board:hover {
    background-color: #c2c2cd;
  }

</style>

<script>

  import BoardMini from './BoardMini.vue'

  /**
   *
   *
   */
  export default {

    name: 'BoardsNavigator',

    components: { BoardMini },

    /**
     * Входные данные.
     *
     */
    props: {

      // Название группы досок
      name: {
        type: String,
        required: true
      },

      // Сообщение, если список пустой
      empty: {
        type: String,
        required: false,
        default: 'В данной категории пока еще нет досок'
      },

      filter: {
        type: Function,
        required: true
      },

      // Доски
      boards: {
        type: Array,
        required: true
      },

      // Разрешение
      addBoardEnabled: {
        type: Boolean,
        required: false,
        default: false
      }
    },

    /**
     *
     *
     */
    data() {

      return {

        filterBoards: []
      }
    },

    /**
     * Инициализация входных системных данных.
     *
     */
    watch: {

      /**
       * Статус избранного.
       *
       */
      boards: {

        handler( boards ) {
          this.filterBoards = this.filter( boards )
        },

        // Необходимо для инициализации значения по умолчанию
        immediate: true,

        // Необходимо для отслеживания всех свойств объекта на всю глубину
        deep: true
      }
    },

    /**
     *
     *
     */
    computed: {

    },

    /**
     *
     *
     */
    methods: {

      /**
       * Инициализация компонента.
       *
       */
      init() {

      },

      /**
       *
       *
       */
      selectBoard( board ) {

        this.$emit( 'selectBoard', board )
      },

      // /**
      //  *
      //  *
      //  */
      // isFavorite( board ) {
      //   return board.favorite
      // },

      /**
       *
       *
       */
      favoriteBoard( board, isFavorite ) {

        this.$emit( 'favorite', board, isFavorite )
      },

      /**
       *
       *
       */
      addBoard() {

        this.$emit( 'addBoard' )
      },

      /**
       *
       *
       */
      editBoard( board ) {

        this.$emit( 'editBoard', board )
      },

      /**
       *
       *
       */
      deleteBoard( board ) {

        this.$emit( 'deleteBoard', board )
      },

      /**
       *
       *
       */
      shareBoard( board ) {

        this.$emit( 'shareBoard', board )
      },
    }
  }

</script>



// WEBPACK FOOTER //
// src/apps/bpm/kanban/components/BoardsNavigator.vue